import { FunctionComponent } from 'react';
import { BodyText, Div, Gutter } from '@gaiads/telia-react-component-library';
import { useTranslation } from 'react-i18next';

interface VerifyPhoneNumberProps {
  phoneNumber: string;
}

const VerifyPhoneNumber: FunctionComponent<VerifyPhoneNumberProps> = ({ phoneNumber }) => {
  const { t } = useTranslation('phoneNumberVerification');

  return (
    <Div>
      <BodyText size={'sm'}>{t('VerifyPhoneNumber.introText')}</BodyText>
      <Gutter />
      <BodyText size={'sm'}>
        {t('VerifyPhoneNumber.getPasscode')} <b>{phoneNumber}</b>
      </BodyText>
      <Gutter />
      <BodyText size={'sm'} color={'gray400'}>
        {t('VerifyPhoneNumber.wrongNumber')}
      </BodyText>
    </Div>
  );
};

export default VerifyPhoneNumber;
